import { render, staticRenderFns } from "./tablaCmabioshistorico.vue?vue&type=template&id=1ea0ac35"
import script from "./tablaCmabioshistorico.vue?vue&type=script&lang=js"
export * from "./tablaCmabioshistorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports